var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-data-editor',{attrs:{"id":_vm.id,"title":"Редактирование единицы измерения веса","resource":"units","elements":_vm.elements,"add-message":"Единица измерения добавлена","edit-message":"Единица измерения изменена"},on:{"change":(payload) => _vm.isChanged = payload}})
}
var staticRenderFns = []

export { render, staticRenderFns }